/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Icon from 'bf-library/Icon';
import Modal from 'bf-library/Modal';
import Button from 'bf-library/Button';

function CouponInfo(props) {
    const { couponCode, applyCoupon, couponVoucherTerm, updateCoupon } = props;
    const [ isModalOpen, setIsModalOpen ] = useState(false);

    function removeCoupon() {
        applyCoupon('');
        updateCoupon('');
        setIsModalOpen(false);
    }

    return (
        <div className="kbe-coupon-info-main-wrapper">
            <div className="kbe-coupon-info">
                <div className="kbe-coupon-info-label">
                    <FormattedMessage id="bf.certificateUsed" defaultMessage="bf.certificateUsed" values={{ couponVoucherTerm }} />
                </div>
                <div className="kbe-coupon-info-code">
                    {couponCode}
                </div>
            </div>
            <div className="kbe-coupon-remove-trigger-wrapper" onClick={() => setIsModalOpen(true)}>
                <div className="kbe-coupon-remove-trigger">
                    <Icon
                        className="kbe-coupon-remove-trigger-icon"
                        name="bf-icon-trash-bin"
                    />
                </div>
            </div>
            <Modal
                externalOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title={<FormattedMessage id="bf.removeCoupon" defaultMessage="bf.removeCoupon" values={{ couponVoucherTerm }} />}
                content={<FormattedMessage
                    id="bf.sureToRemoveCouponQuestion"
                    defaultMessage="bf.sureToRemoveCouponQuestion"
                    values={{ couponVoucherTerm }}
                />}
                footer={(
                    <div className="kbe-coupon-remove-confirmation-buttons-wrapper">
                        <Button
                            content={<FormattedMessage id="bf.cancel" defaultMessage="bf.cancel" />}
                            onClick={() => setIsModalOpen(false)}
                        />
                        <Button
                            content={<FormattedMessage
                                id="bf.removeCouponConfirmation"
                                defaultMessage="bf.removeCouponConfirmation"
                                values={{ couponVoucherTerm }}
                            />}
                            onClick={() => removeCoupon()}
                            primary
                        />
                    </div>
                )}
                size="small"
            />
        </div>
    );
}

CouponInfo.propTypes = {
    couponCode        : PropTypes.string.isRequired,
    applyCoupon       : PropTypes.func.isRequired,
    updateCoupon      : PropTypes.func.isRequired,
    couponVoucherTerm : PropTypes.string.isRequired,
};

export default CouponInfo;

